import * as React from 'react'
export const LiveChatIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={85} height={84} fill="none" {...props}>
    <g filter="url(#a)">
      <circle cx={42.5} cy={42} r={22} fill="#fff" />
    </g>
    <g clipPath="url(#b)">
      <path
        fill="#E12468"
        stroke="#E12468"
        d="m48.819 48.425-.23.445c.233.12.461.234.696.341 1.095.503 2.346.912 3.592 1.034l1.034.1a.392.392 0 0 1-.311.155c-1.515 0-3.072-.478-4.391-1.089h-.003a13.73 13.73 0 0 1-.517-.25l-.151-.078-.167.032a9.112 9.112 0 0 1-1.671.166c-2.62 0-4.89-1.17-6.174-2.89l.228-.051c1.246 1.615 3.385 2.722 5.946 2.722.62 0 1.227-.077 1.835-.2h.004a.084.084 0 0 1 .053.01l.227-.447Zm0 0c.228.119.45.229.675.332l-8.535-2.986c1.106 1.622 3.183 2.791 5.741 2.791.578 0 1.151-.072 1.736-.19a.583.583 0 0 1 .383.053Zm-12.355-4.438h.001c.611.123 1.22.2 1.835.2 4.043 0 7.1-2.794 7.1-5.984s-3.057-5.984-7.1-5.984c-4.043 0-7.1 2.795-7.1 5.984 0 1.59.764 2.89 1.827 4.022.032.033.04.086.017.13l-.001.003c-.402.762-.832 1.52-1.364 2.208l-.636.825a.43.43 0 0 1-.007-.016l-.002-.004a.418.418 0 0 1 .07-.442l.004-.003.007-.008c.62-.687 1.103-1.474 1.548-2.285l.167-.304-.226-.263C31.668 40.982 31 39.726 31 38.203 31 34.85 34.194 32 38.3 32s7.3 2.853 7.3 6.207c0 3.354-3.194 6.203-7.3 6.203-.566 0-1.12-.064-1.671-.167l-.164-.03-.15.074c-.177.088-.346.172-.521.252h-.002c-1.32.608-2.877 1.086-4.392 1.086a.388.388 0 0 1-.312-.158l1.034-.097c1.246-.117 2.494-.527 3.593-1.034.235-.107.463-.221.696-.341l.002-.002a.076.076 0 0 1 .051-.006Zm-2.979-1.396a.613.613 0 0 0-.094-.709c-1.016-1.081-1.691-2.266-1.691-3.679 0-2.849 2.764-5.484 6.6-5.484s6.6 2.635 6.6 5.484-2.764 5.484-6.6 5.484a8.812 8.812 0 0 1-1.736-.19l-3.079-.906Zm14.245-5.437a7.36 7.36 0 0 0-.033-.218c3.619.417 6.303 3.066 6.303 6.146 0 1.523-.668 2.779-1.604 3.863l-.226.263.167.304c.445.812.928 1.594 1.547 2.283l.008.009.004.004a.425.425 0 0 1 .07.442l-.001.002a.47.47 0 0 1-.008.018l-.636-.828c-.532-.693-.958-1.447-1.364-2.211a.113.113 0 0 1 .015-.13l.001-.001c1.063-1.132 1.827-2.433 1.827-4.022 0-2.912-2.553-5.5-6.07-5.924Z"
      />
    </g>
    <defs>
      <clipPath id="b">
        <path fill="#fff" d="M30.5 30h24v24h-24z" />
      </clipPath>
      <filter
        id="a"
        width={84}
        height={84}
        x={0.5}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={10} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_10204_270994" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_10204_270994" result="shape" />
      </filter>
    </defs>
  </svg>
)
